// Normalizes the various raw invoice payload shapes used across
// pos / retail / wholesale / ecom invoice screens into one common shape
// consumed by A4InvoiceTemplate / ThermalInvoiceTemplate.
//
// rawInvoice is expected to look like: { sales_invoice, sales_invoice_products, store_info }
// (this is the shape already used by QuickinvoiceReciptPrint.js / PrintInvoice.js / InvoicePrint.js)
export function normalizeInvoiceForPrint(rawInvoice, invoiceType) {
  const data = rawInvoice || {};
  const header = data.sales_invoice || data.invoice || {};
  const products =
    data.sales_invoice_products ||
    data.invoice_products ||
    data.line_items ||
    data.items ||
    [];
  const storeInfoRaw = data.store_info || {};

  const items = (products || []).map((p) => ({
    name: p.product_name || p.name || p.item_name || "N/A",
    qty: parseFloat(p.sold_qty_stock ?? p.qty ?? p.quantity ?? 0) || 0,
    rate: parseFloat(p.selling_price ?? p.rate ?? p.price ?? 0) || 0,
    discount: parseFloat(p.discount ?? p.item_discount ?? 0) || 0,
    tax: parseFloat(p.tax_amount ?? p.gst_amount ?? 0) || 0,
    amount: parseFloat(p.total_amount ?? p.amount ?? 0) || 0,
  }));

  const totalQty = items.reduce((t, i) => t + i.qty, 0);
  const subTotal = items.reduce((t, i) => t + i.amount, 0);

  return {
    invoiceType,
    invoiceNo: header.invoice_no || header.bill_no || header.id || "N/A",
    date: header.date || header.invoice_date || header.created_at || "",
    customer: {
      name: header.customer_name || header.customer?.name || "Walk-in Customer",
      address: header.customer_address || header.customer?.address || "",
      phone: header.customer_phone || header.customer?.phone || "",
    },
    items,
    totals: {
      totalQty,
      subTotal,
      taxAmount: parseFloat(header.tax_amount ?? header.gst_amount ?? 0) || 0,
      discountAmount: parseFloat(header.discount_amount ?? header.discount ?? 0) || 0,
      roundOff: parseFloat(header.round_off ?? 0) || 0,
      payableAmount: parseFloat(header.payable_amount ?? subTotal) || subTotal,
      payMethod: header.pay_method || header.payment_method || "N/A",
    },
    currencySymbol: header.currency_symbol || "₹",
    storeInfoRaw,
  };
}

export default normalizeInvoiceForPrint;
